import $ from 'jquery'
import HTTP from '@/components/general/http/http'

import config from '@/config/env'

export default {
	createContract(data) {

		let url = config.api.baseUrl + '/api/sda'

		return HTTP
			.request()
			.post(url, data)
			.then(response => response)
			.catch(error => error)

	},
	getSDAs(data) {

		let url = config.api.baseUrl + '/api/sda' + data

		return HTTP
			.request()
			.get(url)
			.then(response => response)
			.catch(error => error)

	},
	migrateCSVFile(router, data) {

		let url = config.api.baseUrl + router

		return HTTP
			.request()
			.post(url, data)
			.then(response => response)
			.catch(error => error)

	},
	sendMailDigitalSignature(data) {

		let url = `${config.api.baseUrl}/api/sda/digital-signature/send-mail`;

		return HTTP.request().put(url, data)

	},
	exportZipPDFs(data) {

		let url = config.api.baseUrl + '/api/sda/exportZipPDFs'

		return HTTP
			.request()
			.post(url, data)
			.then(response => response)
			.catch(error => error)

	},
	getExportZipPDFs(archiveId) {

		let url = config.api.baseUrl + '/api/sda/exportZipPDFs/' + archiveId

		return HTTP
			.request()
			.get(url, {
				responseType: 'arraybuffer',
				onDownloadProgress: function (progressEvent) {

					if (progressEvent.loaded > 0 && progressEvent.total > 0) {

						let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
						$('#progress_id_export_zippdf_download').text(percentCompleted + '%');
						$('#progress_id_export_zippdf_download').attr("aria-valuenow", percentCompleted);
						$('#progress_id_export_zippdf_download').css("width", percentCompleted + "%");

					}


				}
			})
			.then(response => response)
			.catch(error => error)

	}
}




// WEBPACK FOOTER //
// ./src/api/sda.js